// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__7qyJa","arrow":"styles_arrow__V3hep","tooltipContent":"styles_tooltipContent__N+alc"};